import { isMobile } from "../utils/methods";
import { BaseSearchFormItemProps } from "../SearchForm/interface/baseInterface";
import { toolBarType } from "../SuperTable/subpage/tableToolbar";
import { productInfoProps } from "../SuperTable/interface";
import { OptionItem } from "../GoodInfoColumn/interface";

/** 成功状态码 */
export const SUCCESS_STATUS_CODE: string = "00000";
/** 表格包裹ID */
export const TABLE_CONTENT_ID: string = 'tl_page_content';
/** 新增按钮 */
export const TABLE_ADD_BUTTON_ID: string = 'yb_table_add_button';
/** 编辑按钮 */
export const TABLE_OK_BUTTON_ID: string = 'yb_table_ok_button';
/** 草稿箱按钮 */
export const TABLE_DRAFTS_BUTTON_ID: string = 'yb_table_ok_button';
/** 详情转编辑按钮 */
export const TABLE_DETAIL_BUTTON_ID: string = 'yb_table_detail_button';
/** 取消按钮 */
export const TABLE_CANCEL_BUTTON_ID: string = 'yb_table_cancel_button';
/** 超过多久未操作被鉴定为空闲时间（分钟） */
export const FREE_TIME_NAME: string = 'FREE_TIME';
export const FREE_TIME_VALUE: number = 60;
/** 延续token时间(分钟) */
export const TOKEN_INTERVAL_TIME_NAME: string = 'TOKEN_INTERVAL_TIME';
export const TOKEN_INTERVAL_TIME_VALUE: number = 10;
/** 至少需要提前多少分钟弹窗提示token即将过期 */
export const MIN_PROMPT_TIME_NAME: string = 'MIN_PROMPT_TIME';
export const MIN_PROMPT_TIME_VALUE: number = 5;
/** 项目默认图标 */
export const DEFAULT_PROJECT_ICON: string = 'chanpin';
/** 分组默认图标 */
export const DEFAULT_MODULE_ICON: string = 'model';
/** 页面默认图标 */
export const DEFAULT_PAGE_ICON: string = 'dingdandingdanchaxun';
/** 表格左右布局时左部的默认宽度 */
export const DEFAULT_TABLE_LEFT_WIDTH: number = 270;
/** 表格无数据时的占位符 */
export const TABLE_COLUMN_EMPTY: string = '--';
/** 可编辑表格状态字段 */
export const STATUS_CREATED_CODE: string = 'recordStatus';
/** 可编辑表格状态字段 */
export const ROW_INDEX_CODE: string = 'rowIndex';
/** 可编辑表格排序字段 */
export const DISPLAY_ORDER_FIELD: string = 'displayOrder';
/** 重定向路径 */
export const REDIRECT_URL: string = `${window.location.origin}/authorize`;
/** 登录路径 */
export const LOGIN_URL: string = process.env.NODE_ENV === "production" ? `${window.location.origin}/login` : `${window.location.origin}/login`;
/** 是否在移动端打开 */
export const IS_MOBILE: boolean = isMobile();
//
export const WEb_SOCKET_URL: string = 'ws://localhost:38083';
/** 缩略图文件名结尾 */
export const IMAGE_THUMB_NAME: string = '_thumbnail';
/** 全部状态key值 */
export const ALL_STATUS: string = 'ALL';
/** 钉钉 */
export const DING_TALK: string = 'dingtalk';
/** paypal */
export const PAY_PAL: string = 'paypal';
/** 可编辑表格数据状态 */
export const STATUS_CREATED = {
  /** 默认 */
  DEFAULT: 1,
  /** 新增 */
  ADD: 2,
  /** 修改 */
  UPDATE: 4,
  /** 删除 */
  DELETE: 8,
};
/** 可编辑表格是否为历史数据 */
export const HISTORY_LIST_DATA: string = 'HISTORY_LIST_DATA';
/** 默认日期格式 */
export const DEFAULT_DATA_FORMAT: string = 'YYYY-MM-DD';
/** 默认时间格式 */
export const DETAULT_TIME_FORMAT: string = 'HH:mm:ss';
/** 下拉匹配组件分隔符 */
export const ASSOCIATE_INPUT_SPLIT: string = '@@#';
/** 新增订单号 */
export const ADD_ORDER_SN = '系统自动生成';
/** 下拉选择框单个选项最大展示长度 */
export const MAX_TAG_TEXT_LENGTH: number = document.body.clientWidth < 1500 ? 5 : 10;
/** body宽度 */
export const BODY_WIDTH: number = document.body.clientWidth;
/** body高度 */
export const BODY_HEIGHT: number = document.body.clientHeight;
/** 输入类型 */
export const inputTypeCodelist = [
  { value: 'radiobox', label: '单选' },
  { value: 'checkbox', label: '多选' },
  { value: 'text', label: '文本' },
  { value: 'date', label: '日期' },
  { value: 'number', label: '数字' },
];
/** 注册资本 */
export const registerCapital = [
  { label: '0万~10万', value: '0万~10万' },
  { label: '10万~500万', value: '10万~500万' },
  { label: '500万~3000万', value: '500万~3000万' },
  { label: '3000万以上', value: '3000万以上' },
];
/** 人数规模 */
export const employeeNumber = [
  { label: '0-49', value: '0-49' },
  { label: '50-99', value: '50-99' },
  { label: '100-199', value: '100-199' },
  { label: '200-499', value: '200-499' },
  { label: '500-1000', value: '500-1000' },
  { label: '1000以上', value: '1000以上' },
];
/** 表格无复制toolbar */
export const unCopyToolBar: toolBarType[] = [ 'refresh', 'set', ];
/** 时区 */
export const TIME_ZONE_OPTIONS = [
  {
    value: 'CHINA',
    label: '中国时间',
  },
  {
    value: 'LOCAL',
    label: '站点时间',
  },
];
/** 两列表单布局中站位一整行配置 */
export const TWO_COLUMN_FULL_LINE: BaseSearchFormItemProps = {
  span: 24,
  labelCol: {
    span: 4,
  },
  style: { paddingLeft: 6 },
};
/** 三列表单布局中站位2/3行配置 */
export const THREE_COLUMN_UNLINE: BaseSearchFormItemProps = {
  span: 16,
  style: { paddingLeft: 8 },
  labelCol: {
    span: 4,
  },
};
/** 三列表单布局中站位一整行配置 */
export const THREE_COLUMN_FULL_LINE: BaseSearchFormItemProps = {
  span: 24,
  labelCol: { style: { width: '11.11%', flex: '0 0 11.11%' }, span: 3 },
  style: { paddingLeft: 7 },
};
/** 四列单布局中站位1/2行配置 */
export const FOUR_COLUMN_HALF_LINE: BaseSearchFormItemProps = {
  span: 12,
  style: { paddingLeft: 8 },
  labelCol: {
    span: 4,
  },
};
/** 四列单布局中站位3/4行配置 */
export const FOUR_COLUMN_MOST_LINE: BaseSearchFormItemProps = {
  span: 18,
  labelCol: {
    style: {
      width: '11.11%',
      flex: '0 0 11.11%',
    },
    span: 3,
  },
  style: {
    paddingLeft: 6,
  },
};
/** 四列单布局中站位一整行配置 */
export const FOUR_COLUMN_FULL_LINE: BaseSearchFormItemProps = {
  span: 24,
  labelCol: {
    span: 2,
    style: {
      width: '11.11%',
      flex: '0 0 11.11%',
    },
  },
  style: {
    marginLeft: -5,
  },
};
/** 表单宽度 */
export const FORMITEM_WIDTH_ENUM = {
  /** 100 */
  small: 100,
  /** 130 */
  default: 130,
  /** 180 */
  big: 180,
  /** 220 */
  biger: 220,
  /** 260 */
  makeUp: 260,
  /** 310 */
  long: 310,
  /** 350 */
  longer: 350,
};
/** 表格列宽 */
export const TABLE_COLUMN_WIDTH = {
  /** 卖家SKU */
  sellerSku: 120,
  /** SKU */
  skuCode: 120,
  /** 自定义SKU */
  customizeSkuCode: 115,
  /** 商品名称 */
  productName: 180,
  /** 规格 */
  skuSpecName: 160,
  /** 货号 */
  productCode: 90,
  /** 自定义货号 */
  customizeProductCode: 90,
  /** 单号 */
  orderSn: 140,
  /** 用户名 */
  userName: 70,
  /** 日期+时间 */
  dateTime: 140,
  /** 日期 */
  date: 80,
  /** FNSKU */
  fnSku: 120,
  /** 条码 */
  barcode: 105,
  /** 仓库名 */
  warehouseName: 135,
  /** 卖家名称 */
  vendorName: 110,
  /** 卖家名称 */
  merchantName: 110,
  /** 卖家名称 */
  businessTeamName: 120,
  /** 供应商名称 */
  supplierName: 180,
  /** 店铺 */
  shopName: 120,
  /** asin */
  asin: 100,
  /** 缩略图 */
  image: 60,
  /** 国家 */
  country: 80,
  /** 国家编码 */
  countryCode: 60,
  /** 邮箱 */
  email: 180,
  /** 批次号、系列号 */
  lotNumber: 150,
};
export const goodInfoColumnProps: productInfoProps = {
  image: (goodInfo: any) => goodInfo?.productImageFullUrl,
  title: (goodInfo: any) => goodInfo?.productName,
  options: (goodInfo: any) => {
    const newOptions: OptionItem[] = [];
    if (goodInfo?.productCode) {
      newOptions.push({
        label: '货号',
        value: goodInfo?.productCode,
      });
    }
    return newOptions;
  },
};
